import * as React from 'react'
import classnames from 'classnames'
import { Field, Form, FormikProps, withFormik } from 'formik'
import { ButtonVariant, OvalButton, Spacer } from '@revelrygroup/components'
import * as Yup from 'yup'

import { TwoColumnLabelRadio } from '../elements/TwoColumnLabelRadio'
import styles from './styles.module.scss'
import { MemorialTree } from '../../types'

const validationSchema = Yup.object({
  product_id: Yup.string().required('Required'),
})

export interface FormValues {
  buy_now?: boolean
  product_id: string
}

interface Props {
  initialValues: FormValues
  memorialTrees: MemorialTree[]
  onSubmit: (values: FormValues) => Promise<void>
  submitDisabled: boolean
}

const MemorialTreeForm: React.FC<Props & FormikProps<FormValues>> = (props) => {
  const btnDisabled = props.isSubmitting || !props.isValid || props.submitDisabled

  return (
    <Form>
      {props.memorialTrees.map((memorialTree) => (
        <div key={memorialTree.product_id}>
          <Field
            as={TwoColumnLabelRadio}
            checked={props.values.product_id === memorialTree.product_id}
            name="product_id"
            value={memorialTree.product_id}
            firstLabelClassName={classnames('body', 'bold800')}
            firstLabelText={memorialTree.name}
            secondLabelClassName="body"
            secondLabelText={memorialTree.description}
            wrapperClassName={styles.labelWrapper}
          />
        </div>
      ))}

      <Spacer verticalTop="md">
        <OvalButton
          as="button"
          variant={ButtonVariant.DEFAULT_DARK}
          disabled={btnDisabled}
          onClick={() => {
            if (props.isValid) {
              props.onSubmit({ ...props.values, buy_now: true })
            }
          }}
          type="button"
        >
          Buy Now
        </OvalButton>

        <Spacer horizontalLeft="md" inline>
          <button
            className={styles.addToCartBtn}
            disabled={btnDisabled}
            onClick={() => {
              if (props.isValid) {
                props.onSubmit({ ...props.values, buy_now: false })
              }
            }}
            type="button"
          >
            Add to Basket
          </button>
        </Spacer>
      </Spacer>
    </Form>
  )
}

export default withFormik<Props, FormValues>({
  displayName: 'MemorialTreeForm',
  handleSubmit: async (values, { props }) => props.onSubmit(values),
  mapPropsToValues: (props) => props.initialValues,
  validateOnMount: true,
  validationSchema,
})(MemorialTreeForm)
